// Las alturas guardadas en `athletes.attributes.height` llegan en unidades
// mixtas: el onboarding antiguo guardaba metros (1.85) y el actual centímetros
// (185). La UI las concatenaba con "cm" sin normalizar, así que en las tarjetas
// del scout se leía "1.85cm". Normalizamos siempre a centímetros enteros.
//
// Heurística: ninguna persona mide menos de 3 cm, así que un valor < 3 sólo
// puede venir expresado en metros.
const METERS_THRESHOLD = 3;

/** Devuelve la altura en centímetros (número) o `null` si no hay dato válido. */
export const toCentimeters = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) return null;
  return Math.round(parsed < METERS_THRESHOLD ? parsed * 100 : parsed);
};

/** Altura lista para mostrar: "185 cm", o el placeholder si no hay dato. */
export const formatHeight = (value, placeholder = "—") => {
  const cm = toCentimeters(value);
  return cm === null ? placeholder : `${cm} cm`;
};

export default formatHeight;
